import { render, staticRenderFns } from "./WorkerJobsPage.vue?vue&type=template&id=135f6074&scoped=true&"
import script from "./WorkerJobsPage.vue?vue&type=script&lang=js&"
export * from "./WorkerJobsPage.vue?vue&type=script&lang=js&"
import style0 from "./WorkerJobsPage.vue?vue&type=style&index=0&id=135f6074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135f6074",
  null
  
)

export default component.exports